const touristMode = process.env.REACT_APP_TOURIST_MODE === "1";
export default touristMode;
